import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@app/ui/sports-components/utils/classNames';

const defaultPhoto = 'https://assets.ggops.com/images/avatar.jpg';

const Avatar = ({ alt = "Profile's Photo", src, ...otherProps }) => {
    const srcUrl = typeof src === 'string' ? src : defaultPhoto;

    const className = classNames(
        'gds-avatar__image -color-bg-white gds-flex mvc-refresh-avatar',
    );

    return (
        <div className={className} {...otherProps}>
            <img src={srcUrl} height="100%" width="100%" alt={alt} />
        </div>
    );
};

Avatar.propTypes = {
    alt: PropTypes.string,
    src: PropTypes.string,
};

export default Avatar;
